import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { hu } from 'date-fns/locale';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Login from './pages/Login';
import About from './pages/About';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import Privacy from './pages/Privacy';
import Imprint from './pages/Imprint';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import MusicPlayer from './components/MusicPlayer';
import './styles/App.scss';

const theme = createTheme({
    palette: {
        primary: {
            main: '#2e7d32',
            light: '#60ad5e',
            dark: '#005005',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#00695c',
            light: '#439889',
            dark: '#003d33',
            contrastText: '#ffffff',
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff',
        },
        text: {
            primary: '#333333',
            secondary: '#666666',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Arial", sans-serif',
        h1: { fontWeight: 700 },
        h2: { fontWeight: 600 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 500 },
        h5: { fontWeight: 500 },
        h6: { fontWeight: 500 },
    },
    components: {
        MuiDatePicker: {
            defaultProps: {
                inputFormat: 'yyyy.MM.dd',
            },
        },
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={hu}
                dateFormats={{ keyboardDate: 'yyyy.MM.dd' }}
            >
                <AuthProvider>
                    <Router>
                        <ScrollToTop />
                        <div className="app">
                            <Navbar />
                            <main className="main-content">
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/szolgaltatasok" element={<Services />} />
                                    <Route path="/projektek" element={<Projects />} />
                                    <Route path="/rolunk" element={<About />} />
                                    <Route path="/kapcsolat" element={<Contact />} />
                                    <Route path="/admin/login" element={<Login />} />
                                    <Route
                                        path="/admin/*"
                                        element={
                                            <ProtectedRoute>
                                                <Admin />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route path="/adatkezeles" element={<Privacy />} />
                                    <Route path="/impresszum" element={<Imprint />} />
                                    <Route path="/gyik" element={<FAQ />} />
                                    <Route path="/aszf" element={<Terms />} />
                                </Routes>
                            </main>
                            <Footer />
                            <CookieBanner />
                            <MusicPlayer />
                        </div>
                    </Router>
                </AuthProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;